import {
  AddressCollectionSchema,
  addressTypeSchema,
} from "@redotech/redo-return-core-common/address-collection";
import * as z from "zod";

export const getAddressCollections = {
  name: "getAddressCollections" as const,
  input: z.object({ types: z.array(addressTypeSchema) }),
  output: z.object({ addresses: z.array(AddressCollectionSchema) }),
};
